import { Link } from 'react-router-dom';
import { useDocs } from '../hooks/useDocs';
import { useSettings } from '../hooks/useSettings';

const DocsLanding = () => {
  const { data: docs } = useDocs();
  const { settings } = useSettings();
  const featured = docs?.slice(0, 3) || [];

  // Get the secondary button link - if not set, link to first doc
  const secondaryButtonLink = settings?.secondaryButtonLink
    ? settings.secondaryButtonLink
    : featured[0]?.slug
    ? `/docs/${featured[0].slug}`
    : '/';

  // Determine if secondary button should be external link or internal
  const isSecondaryExternal = settings?.secondaryButtonLink && 
    (settings.secondaryButtonLink.startsWith('http://') || settings.secondaryButtonLink.startsWith('https://'));

  return (
    <div className="space-y-8">
      <section className="rounded-3xl border border-slate-200 bg-gradient-to-br from-brand-50 via-white to-white p-8 shadow-card dark:from-slate-900 dark:via-slate-900 dark:to-slate-950">
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-500">
          {settings?.platformName || 'Workloob'} Docs
        </p>
        <h2 className="mt-2 text-4xl font-bold text-slate-900 dark:text-white">
          {settings?.heroTitle || 'Build better workflows with Workloob'}
        </h2>
        <p className="mt-3 max-w-2xl text-lg text-slate-600 dark:text-slate-300">
          {settings?.heroDescription || 'Explore APIs, SDKs, and operational guides for everything from onboarding to advanced automation inside the Workloob platform.'}
        </p>
        <div className="mt-6 flex flex-wrap gap-4">
          {settings?.primaryButtonText && (
            <a
              href={settings.primaryButtonLink || 'https://app.workloob.com'}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-2xl bg-brand-600 px-6 py-3 text-white shadow-lg shadow-brand-500/30 transition hover:bg-brand-500"
            >
              {settings.primaryButtonText}
            </a>
          )}
          {settings?.secondaryButtonText && (
            isSecondaryExternal ? (
              <a
                href={secondaryButtonLink}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-2xl border border-slate-200 px-6 py-3 text-slate-700 transition hover:border-brand-300 hover:text-brand-600 dark:border-slate-700 dark:text-slate-200"
              >
                {settings.secondaryButtonText}
              </a>
            ) : (
              <Link
                to={secondaryButtonLink}
                className="rounded-2xl border border-slate-200 px-6 py-3 text-slate-700 transition hover:border-brand-300 hover:text-brand-600 dark:border-slate-700 dark:text-slate-200"
              >
                {settings.secondaryButtonText}
              </Link>
            )
          )}
        </div>
      </section>

      <section className="grid gap-6 md:grid-cols-3">
        {featured.map((doc) => (
          <Link
            key={doc._id}
            to={`/docs/${doc.slug}`}
            className="group rounded-3xl border border-slate-200 bg-white/80 p-6 shadow-card transition hover:-translate-y-1 hover:border-brand-300 hover:shadow-2xl dark:border-slate-800 dark:bg-slate-900/70"
          >
            <p className="text-xs font-semibold uppercase tracking-wider text-brand-500">{doc.category}</p>
            <h3 className="mt-2 text-2xl font-semibold text-slate-900 dark:text-white">{doc.title}</h3>
            <p className="mt-2 text-sm text-slate-500 dark:text-slate-300">{doc.description}</p>
            <span className="mt-4 inline-flex items-center text-sm font-semibold text-brand-600">
              Read more →
            </span>
          </Link>
        ))}
      </section>
    </div>
  );
};

export default DocsLanding;

